import { createFileRoute } from "@tanstack/react-router";

import { RoutePage, routeEntry } from "./routeTable";

const entry = routeEntry("/lane-workspace/:laneId");

export const Route = createFileRoute("/lane-workspace/$laneId")({
  head: () => ({
    meta: [
      { title: "Lane workspace detail — LevelLoad" },
      {
        name: "description",
        content: "One lane's details, report, carriers and plan days in LevelLoad.",
      },
      { property: "og:title", content: "Lane workspace detail — LevelLoad" },
      {
        property: "og:description",
        content: "One lane's details, report, carriers and plan days in LevelLoad.",
      },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary_large_image" },
    ],
  }),
  component: RouteComponent,
});

function RouteComponent() {
  return <RoutePage entry={entry} />;
}
